import { HttpClientService } from './../httpClient/httpclient.service';
import { ListMetadata } from './../../models/list-metadata.model';
import { Observable } from 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { publishReplay, refCount } from 'rxjs/operators';
import { MessageService } from 'primeng/primeng';


@Injectable()
export class PromotionCatalogGiftService {
  baseUrl = '/koncentro-promo';
  catalogId: number;
  cachedCatalogGiftFields: Observable<any>;
  cachedCatalogGiftItemFields: Observable<any>;

  constructor(
    private http: HttpClientService,
    private srvNotify: MessageService
  ) { }

  getCatalogId(id: number) {
    this.catalogId = id;
  }

  /**
    * Tramite metodo GET, restituisce la lista dei Premi relativi ad un Catalogo.
    * Prevede obbligatoriamente un offset ed un limite, permettendo la paginazione della lista.
  */
  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<any>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + `/catalog-gift/getCatalogGiftList?catalog_id=${this.catalogId}&list=true` +
      (params.toString() ? '&' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : '' ));
  }

  getCatlogGiftFields() {
    if (!this.cachedCatalogGiftFields) {
      this.cachedCatalogGiftFields = this.http.get(`${this.baseUrl}/schema/CatalogGiftDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedCatalogGiftFields;
  }

  getCatlogGiftItemFields() {
    if (!this.cachedCatalogGiftItemFields) {
      this.cachedCatalogGiftItemFields = this.http.get(`${this.baseUrl}/schema/CatalogGiftItemDto`).pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedCatalogGiftItemFields;
  }

  getCatalogGiftData(giftId: number) {
    return this.http.get(`${this.baseUrl}/catalog-gift/${giftId}`);
  }

  getCatalogGiftItemData(giftId: number) {
    return this.http.get(`${this.baseUrl}/catalog-gift/item?catalog_gift_id=${giftId}`);
  }

  getCatalogGiftTypes() {
    return this.http.get(`${this.baseUrl}/catalog-gift/type`);
  }

  getGiftItemTypes() {
    return this.http.get(`${this.baseUrl}/catalog-gift/item/type`);
  }

  getParamTypes(paramGroup: string) {
    return this.http.get(`koncentro-loyalty/params/?param_group=${paramGroup}`);
  }

  deleteCatalogGift(giftId: number) {
    return this.http.delete(`${this.baseUrl}/catalog-gift/${giftId}`);
  }

  createCatalogGift(data: any) {
    return this.http.post(`${this.baseUrl}/catalog-gift`, data);
  }

  updateCatalogGift(giftId: number, data: any) {
    return this.http.put(`${this.baseUrl}/catalog-gift/${giftId}`, data);
  }

  createCatalogGiftItem(data: any) {
    return this.http.post(`${this.baseUrl}/catalog-gift/item`, data);
  }

  updateCatalogGiftItem(giftItemId: number, data: any) {
    return this.http.put(`${this.baseUrl}/catalog-gift/item/${giftItemId}`, data);
  }

  deleteCatalogGiftItem(giftItemId: number) {
    return this.http.delete(`${this.baseUrl}/catalog-gift/item/${giftItemId}`);
  }

  recoverCatalogGift(giftId: any) {
    return this.http.put(`${this.baseUrl}/catalog-gift/item/recover/${giftId.id}`, giftId)
    .map(res => {
      this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
    });  }

}



// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion-catalog-gift.service.ts